/**
 * Vive aparte del registro para que las rutas que solo redirigen no arrastren el Markdown al chunk
 * principal: el contenido se carga con la página, bajo demanda.
 */
export const DEFAULT_DOC_ID = 'integracion';
export const DEFAULT_SECTION_SLUG = 'introduccion';
